export default __webpack_public_path__ + "assets/models/c94d6f2b99003ff88e17dc8647dd437a.glb";